import type { PartnerCockpitOfferRequest } from '@houzy/schemas/partner-cockpit/offer-requests';
import type { DeclineMatchingResponse } from '@houzy/schemas/partner-cockpit/partner-matching';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { useTrackEvent } from '../../../lib/trackingEvents';
import { postDeclineMatching } from './matchingApi';
import { offerRequestDetailQueryKey } from './useOfferRequestDetail';
import { offerRequestsSegmentKey } from './useOfferRequestsList';

// Only a matched lead can be declined, and its uuid is its matching uuid.
type DeclinableLead = Pick<PartnerCockpitOfferRequest, 'uuid' | 'referenceId'>;

export function useDeclineMatching(): UseMutationResult<DeclineMatchingResponse, Error, DeclinableLead> {
    const queryClient = useQueryClient();
    const track = useTrackEvent();
    return useMutation({
        mutationFn: (matching) => postDeclineMatching(matching.uuid),
        onSuccess: (_response, matching) => {
            track('Offer Request Declined', { offerRequestId: matching.referenceId });
            void queryClient.invalidateQueries({ queryKey: offerRequestDetailQueryKey(matching.uuid), exact: true });
            void queryClient.invalidateQueries({ queryKey: offerRequestsSegmentKey('new') });
        },
    });
}
